/**
 * 
 * @param {number} numOfPages
 * @returns {number} number of extra pages to add to the flyer
 */
export function getExtraNumOfPages(numOfPages, isMobile) {
  if (isMobile) {
    return Math.ceil(numOfPages / 2) - 1
  }

  return Math.floor(numOfPages / 4)
}

/**
 * 
 * @param {number} numOfPages 
 * @returns {number[]} array of page numbers where instead of a flyer page, an extra page will be shown. The page numbers are positioned respect to the original list of pages of the flyer
 */
export function getExtraPageNumbers(numOfPages, isMobile) {
  const indexArray = Array.from({ length: getExtraNumOfPages(numOfPages, isMobile) })

  return indexArray.map((_, i) => (i + 1) * 3)
}

/**
 * 
 * @param {number} numOfPages 
 * @returns an object with values in the @doveconviene/react-sf-viewer extras format (except callbacks)
 */
export function getFlyerExtrasBase(numOfPages, isMobile, backgroundImageUrls) {
  const pageNumbers = getExtraPageNumbers(numOfPages, isMobile)

  const extrasBaseArray = pageNumbers
    .map((position, index) => {
      return {
        id: `retail_media_slide_${index}`,
        position,
        content_type: 'slide',
        template: backgroundImageUrls
          ? {
            backgroundImageUrl: {
              small: backgroundImageUrls.small,
              large: backgroundImageUrls.large,
            }
          }
          : undefined,
      }
    })

  return {
    pageNumbers,
    extrasBaseArray,
  }
}

export function getBottomRetailMediaBannerSize(isMobile) {
  return isMobile
    ? { width: 320, height: 50 }
    : { width: 728, height: 90 }
}

export function getCenterRetailMediaBannerSize() {
  return { width: 300, height: 250 }
}
